import { Target, ComponentType } from 'data-types-config';
import type { InternalDestinationProps } from './InternalDestination.types';

export const internalDestinationDefaults: Partial<InternalDestinationProps> = {
  target: Target.Self,
  componentType: ComponentType.Internal,
  isDisabled: false,
  isVisible: true,
  text: '',
};
